import { BACKEND_PUBLIC } from './base'

export async function getModerationPage(systemName: string) {
  return BACKEND_PUBLIC.get('/pages/get', { params: { systemName } })
}
